import { render, staticRenderFns } from "./CommunitySetting.vue?vue&type=template&id=3f4d3b0f"
import script from "./CommunitySetting.vue?vue&type=script&lang=js"
export * from "./CommunitySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports